import React from "react";

import { isNullOrEmpty, isNullOrUndefined } from "./../../utils";

import TextHighlights from "./TextWithHighlight";
import "../../search.scss";

interface ResultTitleProps {
  queryResultItem: any;
  attributes: any;
}

export default class ResultTitle extends React.Component<ResultTitleProps, {}> {
  render() {
    const { queryResultItem } = this.props;

    // title is not guaranteed to exist, show nothing if that's the case
    if (
      isNullOrUndefined(queryResultItem.DocumentTitle) ||
      isNullOrEmpty(queryResultItem.DocumentTitle.Text)
    ) {
      return null;
    }

    let resultTitle = (
      <TextHighlights textWithHighlights={queryResultItem.DocumentTitle} />
    );

    const uri = queryResultItem.DocumentURI!;
    if (!isNullOrEmpty(uri)) {
      resultTitle = (
        <b><a className="action-link" href={uri} target="_blank">
          {resultTitle}
        </a></b>
      );
    } else {
      resultTitle = (
          <b><a className="action-link" target="_blank">
            {resultTitle}
          </a></b>
      );
    }

    return <div className="search-result-item">{resultTitle}</div>;
  }
}
